export enum ECountry {
  ES = 'ES',
  AR = 'AR',
  AD = 'AD',
  BO = 'BO',
  BR = 'BR',
  CL = 'CL',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  DO = 'DO',
  EC = 'EC',
  US = 'US',
  FR = 'FR',
  GF = 'GF',
  GT = 'GT',
  HT = 'HT',
  HN = 'HN',
  IN = 'IN',
  JM = 'JM',
  MX = 'MX',
  NI = 'NI',
  PA = 'PA',
  PY = 'PY',
  PE = 'PE',
  PR = 'PR',
  PT = 'PT',
  RU = 'RU',
  SR = 'SR',
  SV = 'SV',
  UY = 'UY',
  VE = 'VE',
  MA = 'MA'
}

export const COUNTRIES = Object.values(ECountry);
